import React from "react";
import logo from '../../layout/leftnav/ppm-logo.png';

const MobileHeader = props => {
    return (
        <div className="mobile-header" id="mobile-header">
            <button className="btn" id="sidebarToggle"><i className="fa fa-bars fa-2x white" onClick={() => toggleSidebar()}></i></button>
            <img src={logo} alt="Payment Portal Logo" />
        </div>
    )
}

export default MobileHeader;

export function toggleSidebar() {
    var sidebarEl = document.getElementById("sidebar-wrapper");
    if (!sidebarEl.classList.contains('open')) {
        sidebarEl.classList.add('open');
    } else {
        sidebarEl.classList.remove('open');
    }
}